import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-nav-tab',
    template: `
    <a mat-button [routerLink]="routerLink" routerLinkActive="active-tab">
      {{ label }}
    </a>
  `,
    styles: [`
    a {
      color: var(--cfa-color-contrast);
      border-bottom: 2px solid transparent;
      border-radius: 0;
    }
    .active-tab {
      color: var(--cfa-color-primary-base);
      border-bottom: 2px solid var(--cfa-color-primary-base);
    }
  `],
    standalone: false
})
export class AppNavTabComponent {
  @Input() label: string;
  @Input() routerLink: string;
  @Input() icon: string;
}
